import { FC, memo } from 'react';
// Import Components
import { Popover, Tag } from '@geneui/components';
// Import SCSS
import styles from './infoValueWithPopover.module.scss';

interface Props {
    data: AnyObject[];
    labelKey: string;
    IdKey: string;
    popoverAlign?: string;
    popoverPosition?: string;
}

const InfoValueWithPopover: FC<Props> = ({
    data,
    labelKey,
    IdKey,
    popoverAlign = 'start',
    popoverPosition = 'right',
}) => {
    return (
        <>
            {data?.length === 1 ? (
                <div className="kv-value-css ellipsis-text">{data[0][labelKey]}</div>
            ) : (
                <Popover
                    Content={
                        <div className={styles.popover}>
                            {data?.map((elem) => {
                                return (
                                    <Tag
                                        key={elem[IdKey]}
                                        name={`${elem[labelKey]}`}
                                        cornerRadius="smooth-radius"
                                        appearance="outline"
                                    />
                                );
                            })}
                        </div>
                    }
                    extendTargetWidth={false}
                    align={popoverAlign}
                    position={popoverPosition}
                >
                    <Tag name={`${data?.length}`} cornerRadius="smooth-radius" appearance="outline" />
                </Popover>
            )}
        </>
    );
};

export default memo(InfoValueWithPopover);
